import { Paper, Table, TableContainer, TableHead, TableCell, TableBody, TableRow, Typography } from "@mui/material";

export default function Reviews({data}){

    const find = (p,c) => {
        const item = data.find(i => i.category === c);
        return parseFloat((item && item[p]) || 0).toLocaleString();
    }

    return <>

        <Typography variant='h3'>Avis</Typography>

        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell></TableCell>
                        <TableCell>Dentaire</TableCell>
                        <TableCell>Kiné</TableCell>
                        <TableCell>Médecine</TableCell>
                        <TableCell>Pharma</TableCell>
                        <TableCell>Santé Mentale</TableCell>
                        <TableCell>Infirmier</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>Nb avis</TableCell>
                        <TableCell>{find('reviews','dentaire')}</TableCell>
                        <TableCell>{find('reviews','kine')}</TableCell>
                        <TableCell>{find('reviews','medecine')}</TableCell>
                        <TableCell>{find('reviews','pharma')}</TableCell>
                        <TableCell>{find('reviews','sante-mentale')}</TableCell>
                        <TableCell>{find('reviews','infirmiere')}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Moyenne avis</TableCell>
                        <TableCell>{find('rating','dentaire')}</TableCell>
                        <TableCell>{find('rating','kine')}</TableCell>
                        <TableCell>{find('rating','medecine')}</TableCell>
                        <TableCell>{find('rating','pharma')}</TableCell>
                        <TableCell>{find('rating','sante-mentale')}</TableCell>
                        <TableCell>{find('rating','infirmiere')}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>

    </>

}